<template>
    <div class="row mb-3 justify-content-center no-gutters">
        <div class="col-12 col-md-11 whiteBG">
            <section class="blockElement p-4">
                <div class="inner-banner-custom row align-items-center">
                    <div class="col-12 col-md-6">
                        <div class="mamPamm-content">
                           <h2 class="mb-3">{{$t('mql_heading')}}</h2>
                           <p>{{$t('mql_text')}}</p>
                             
                            <div class="d-flex align-items-center mt-3"> 
                                  <router-link class="common_btn mr-3"  :to="{path: '/create-live-account' , query: { 'pageName': 'mysql5'}}">{{$t('mql_createliveAcc')}}</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mamPamm text-center">
                           <img src="../../../../../static/fxView/images/mt_signal5.png" alt="MAM/PAMM">
                        </div>
                    </div>  
                </div>
            </section>
           
             <section class="blockElement whiteBG blockTwo overflow-hidden p-4">
                <div class="row mb-3">
                    <div class="col-9">
                        <div class="mamPamm-feature">
                             <h3 class="mb-3">{{$t('mql_stepsRegister')}}</h3>
                            <ul class="listing flexible mb-3">
                               
                                <li class="mb-2">
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mql_stepone')}}</p>
                                </li>
                                <li class="mb-2">
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mql_stepTwo')}}</p>
                                </li>
                                 
                                <li class="mb-2">
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mql_stepThree')}}</p>
                                </li>
                            </ul>
                           <!--  <router-link class="common_btn mr-3"  :to="{path: '/create-live-account' , query: { 'pageName': 'mysql5'}}"  >{{$t('mql_heading')}}</router-link> -->
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Algo Trading',
        data() {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/socialTrade/pages/mql5.vue